<mat-form-field appearance="outline" (click)="picker.open()">
  <mat-label>{{label}}</mat-label>
  <input matInput  [formControl]="date" [matDatepicker]="picker" (dateChange)="addEvent('change', $event)">
  <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="false"></mat-datepicker-toggle>
  <mat-datepicker #picker [disabled]="isDisabled"></mat-datepicker>
</mat-form-field>
